// // // import React, { useState } from 'react';
// // // import { Building2, MapPin, Mail, Phone, Clock, Send } from 'lucide-react';

// // // const VedamsaContactPage = () => {
// // //   const [scrolled, setScrolled] = useState(false);
// // //   const [formData, setFormData] = useState({
// // //     name: '',
// // //     email: '',
// // //     phone: '',
// // //     message: ''
// // //   });

// // //   React.useEffect(() => {
// // //     const handleScroll = () => {
// // //       setScrolled(window.scrollY > 50);
// // //     };
// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, []);

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = (e) => {
// // //     e.preventDefault();
// // //     console.log('Form submitted:', formData);
// // //     // Add your form submission logic here
// // //   };

// // //   return (
// // //     <div className="min-h-screen bg-[#f5f3f0]">
// // //       {/* Header */}
// // //       <header 
// // //         className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
// // //           scrolled 
// // //             ? 'bg-white shadow-lg py-4' 
// // //             : 'bg-white/95 backdrop-blur-sm py-6'
// // //         }`}
// // //       >
// // //         <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
// // //           {/* Logo */}
// // //           <div className="flex items-center space-x-3">
// // //             <div className="bg-black text-white p-2 rounded">
// // //               <Building2 className="w-6 h-6" />
// // //             </div>
// // //             <span className="text-2xl font-bold text-gray-900">Vedamsa</span>
// // //           </div>

// // //           {/* Navigation */}
// // //           <nav className="hidden md:flex items-center space-x-8">
// // //             <a href="#overview" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// // //               Overview
// // //             </a>
// // //             <a href="#pages" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// // //               Pages
// // //             </a>
// // //             <a href="#projects" className="text-gray-700 hover:text-gray-900 transition-colors duration-300 font-medium">
// // //               Projects
// // //             </a>
// // //           </nav>

// // //           {/* CTA Buttons */}
// // //           <div className="flex items-center space-x-4">
// // //             <button className="hidden md:block text-gray-700 hover:text-gray-900 transition-colors duration-300">
// // //               <span className="text-2xl">ⓘ</span>
// // //             </button>
// // //             <button className="bg-gray-200 text-gray-900 px-6 py-2.5 rounded-lg font-medium hover:bg-gray-300 transition-all duration-300">
// // //               More Templates
// // //             </button>
// // //             <button className="bg-[#3d2817] text-white px-6 py-2.5 rounded-lg font-medium hover:bg-[#2d1f10] transition-all duration-300">
// // //               Contact Us
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </header>

// // //       {/* Main Contact Section - Split Layout */}
// // //       <section className="pt-32 pb-20 px-6">
// // //         <div className="max-w-7xl mx-auto">
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
// // //             {/* Left - Content & Info */}
// // //             <div className="bg-[#e8e4df] p-12 rounded-2xl">
// // //               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
// // //                 Get in Touch with<br />Vedamsa
// // //               </h1>
// // //               <p className="text-gray-700 text-lg leading-relaxed mb-12">
// // //                 Whether you have questions, want to schedule a tour, or need assistance with a listing, our team is ready to assist.
// // //               </p>

// // //               {/* Contact Information */}
// // //               <div className="space-y-8">
// // //                 {/* Address */}
// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Address</h3>
// // //                   <p className="text-gray-900 font-medium flex items-start">
// // //                     <MapPin className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
// // //                     Hyderabad, Telangana, India
// // //                   </p>
// // //                 </div>

// // //                 {/* Email */}
// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Email</h3>
// // //                   <a 
// // //                     href="mailto:Vedamsa@gmail.com" 
// // //                     className="text-gray-900 font-medium hover:text-[#3d2817] transition-colors duration-300 flex items-center"
// // //                   >
// // //                     <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
// // //                     Vedamsa@gmail.com
// // //                   </a>
// // //                 </div>

// // //                 {/* Phone */}
// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Phone</h3>
// // //                   <a 
// // //                     href="tel:+918885852266" 
// // //                     className="text-gray-900 font-medium hover:text-[#3d2817] transition-colors duration-300 flex items-center"
// // //                   >
// // //                     <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
// // //                     +91 8885852266
// // //                   </a>
// // //                 </div>

// // //                 {/* Hours */}
// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Hours</h3>
// // //                   <div className="text-gray-900 font-medium flex items-start">
// // //                     <Clock className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
// // //                     <div>
// // //                       <p>Mon-Fri: 9am–6pm</p>
// // //                       <p className="text-gray-500">Sat - Sun: Closed</p>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Right - Contact Form with Dark Marble Background */}
// // //             <div className="relative overflow-hidden rounded-2xl shadow-2xl">
// // //               {/* Dark Marble Background */}
// // //               <div 
// // //                 className="absolute inset-0 bg-cover bg-center"
// // //                 style={{
// // //                   backgroundImage: `url('https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=800')`,
// // //                 }}
// // //               ></div>
// // //               <div className="absolute inset-0 bg-black/60"></div>
              
// // //               {/* Form */}
// // //               <div className="relative z-10 p-12">
// // //                 <form onSubmit={handleSubmit} className="space-y-6">
// // //                   <div>
// // //                     <input
// // //                       type="text"
// // //                       name="name"
// // //                       placeholder="Name"
// // //                       value={formData.name}
// // //                       onChange={handleChange}
// // //                       required
// // //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// // //                     />
// // //                   </div>

// // //                   <div>
// // //                     <input
// // //                       type="email"
// // //                       name="email"
// // //                       placeholder="Email"
// // //                       value={formData.email}
// // //                       onChange={handleChange}
// // //                       required
// // //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// // //                     />
// // //                   </div>

// // //                   <div>
// // //                     <input
// // //                       type="tel"
// // //                       name="phone"
// // //                       placeholder="Phone (optional)"
// // //                       value={formData.phone}
// // //                       onChange={handleChange}
// // //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// // //                     />
// // //                   </div>

// // //                   <div>
// // //                     <textarea
// // //                       name="message"
// // //                       placeholder="Message"
// // //                       value={formData.message}
// // //                       onChange={handleChange}
// // //                       required
// // //                       rows="6"
// // //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500 resize-none"
// // //                     ></textarea>
// // //                   </div>

// // //                   <button
// // //                     type="submit"
// // //                     className="w-full bg-[#3d2817] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#2d1f10] transition-all duration-300 flex items-center justify-center space-x-2 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
// // //                   >
// // //                     <span>Send Message</span>
// // //                     <Send className="w-5 h-5" />
// // //                   </button>
// // //                 </form>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Location Section */}
// // //       <section className="py-20 px-6 bg-white">
// // //         <div className="max-w-7xl mx-auto">
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
// // //             {/* Left - Content */}
// // //             <div>
// // //               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// // //                 Hyderabad, India
// // //               </h2>
// // //               <p className="text-gray-600 text-lg leading-relaxed mb-8">
// // //                 Vedamsa's headquarters serve as the central hub for managing diverse property portfolios and delivering expert real estate solutions to forward-thinking teams across dynamic markets.
// // //               </p>

// // //               <div className="space-y-6">
// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">[ADDRESS]</h3>
// // //                   <p className="text-gray-900 font-medium">Isnapur, Hyderabad, Telangana, India</p>
// // //                 </div>

// // //                 <div>
// // //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">[CONTACT]</h3>
// // //                   <p className="text-gray-900 font-medium">+91 8885852266</p>
// // //                   <p className="text-gray-600">Monday–Friday: 9:00 AM – 6:00 PM</p>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Right - Image */}
// // //             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[600px]">
// // //               <img 
// // //                 src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800"
// // //                 alt="Vedamsa Office"
// // //                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
// // //               />
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Why Vedamsa Section */}
// // //       <section className="py-20 px-6 bg-[#f5f3f0]">
// // //         <div className="max-w-6xl mx-auto">
// // //           <div className="text-center mb-16">
// // //             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// // //               [KEEP IN TOUCH]
// // //             </span>
// // //             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// // //               Why Vedamsa Stands Out
// // //             </h2>
// // //             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
// // //               With nearly 30 years of expertise in the construction industry, Vedamsa has become a trusted name in Hyderabad. Here's what sets Vedamsa apart:
// // //             </p>
// // //           </div>

// // //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// // //             {/* Feature Cards */}
// // //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// // //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// // //                 <Building2 className="w-6 h-6" />
// // //               </div>
// // //               <h3 className="text-xl font-bold text-gray-900 mb-3">Customer-Centric Approach</h3>
// // //               <p className="text-gray-600 leading-relaxed">
// // //                 Over 3000 satisfied customers are a testament to Vedamsa's dedication to delivering quality.
// // //               </p>
// // //             </div>

// // //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// // //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// // //                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
// // //                 </svg>
// // //               </div>
// // //               <h3 className="text-xl font-bold text-gray-900 mb-3">Unmatched Expertise</h3>
// // //               <p className="text-gray-600 leading-relaxed">
// // //                 Vedamsa brings years of experience to every project from plotting to construction.
// // //               </p>
// // //             </div>

// // //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// // //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// // //                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
// // //                 </svg>
// // //               </div>
// // //               <h3 className="text-xl font-bold text-gray-900 mb-3">Sustainability</h3>
// // //               <p className="text-gray-600 leading-relaxed">
// // //                 Environmentally conscious designs that ensure a greener tomorrow.
// // //               </p>
// // //             </div>

// // //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// // //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// // //                 <Clock className="w-6 h-6" />
// // //               </div>
// // //               <h3 className="text-xl font-bold text-gray-900 mb-3">Timely Delivery</h3>
// // //               <p className="text-gray-600 leading-relaxed">
// // //                 A proven track record of completing projects on time.
// // //               </p>
// // //             </div>
// // //           </div>

// // //           <div className="text-center mt-12">
// // //             <p className="text-gray-700 text-lg font-medium">
// // //               When you choose Vedamsa, you're not just buying a home; you're investing in a legacy of trust and excellence.
// // //             </p>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* CTA Section */}
// // //       <section className="py-20 px-6 bg-gray-900">
// // //         <div className="max-w-4xl mx-auto text-center">
// // //           <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
// // //             Ready to Build Your Future?
// // //           </h2>
// // //           <p className="text-gray-300 text-lg leading-relaxed mb-12">
// // //             Let's discuss your dream project. Our team is here to guide you every step of the way.
// // //           </p>
// // //           <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
// // //             <a 
// // //               href="tel:+918885852266"
// // //               className="bg-white text-gray-900 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
// // //             >
// // //               Call Now: +91 8885852266
// // //             </a>
// // //             <a 
// // //               href="mailto:Vedamsa@gmail.com"
// // //               className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300"
// // //             >
// // //               Email Us
// // //             </a>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Footer */}
// // //       <footer className="bg-[#2d1f10] text-white py-12 px-6">
// // //         <div className="max-w-7xl mx-auto">
// // //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
// // //             <div>
// // //               <div className="flex items-center space-x-3 mb-4">
// // //                 <div className="bg-white text-gray-900 p-2 rounded">
// // //                   <Building2 className="w-6 h-6" />
// // //                 </div>
// // //                 <span className="text-2xl font-bold">Vedamsa</span>
// // //               </div>
// // //               <p className="text-gray-400">Building Dreams, Creating Futures</p>
// // //             </div>

// // //             <div>
// // //               <h4 className="font-bold mb-4">Contact</h4>
// // //               <div className="space-y-2 text-gray-400">
// // //                 <p>Hyderabad, India</p>
// // //                 <p>+91 8885852266</p>
// // //                 <p>Vedamsa@gmail.com</p>
// // //               </div>
// // //             </div>

// // //             <div>
// // //               <h4 className="font-bold mb-4">Hours</h4>
// // //               <div className="space-y-2 text-gray-400">
// // //                 <p>Monday - Friday</p>
// // //                 <p>9:00 AM - 6:00 PM</p>
// // //                 <p className="text-gray-500">Weekends: Closed</p>
// // //               </div>
// // //             </div>
// // //           </div>

// // //           <div className="border-t border-gray-700 pt-8 text-center">
// // //             <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
// // //           </div>
// // //         </div>
// // //       </footer>
// // //     </div>
// // //   );
// // // };

// // // export default VedamsaContactPage;


// // import React, { useState } from 'react';
// // import { Building2, MapPin, Mail, Phone, Clock, Send } from 'lucide-react';
// // import post4 from './Images/Poster-3.png';

// // const ContactPage = () => {
// //   const [formData, setFormData] = useState({
// //     name: '',
// //     email: '',
// //     phone: '',
// //     message: ''
// //   });

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     console.log('Form submitted:', formData);
// //     // Add your form submission logic here
// //     alert('Thank you for your message! We will get back to you soon.');
// //     setFormData({ name: '', email: '', phone: '', message: '' });
// //   };

// //   return (
// //     <div className="min-h-screen bg-[#f5f3f0]">
// //       {/* Main Contact Section - Split Layout */}
// //       <section className="pt-32 pb-20 px-6">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
// //             {/* Left - Content & Info */}
// //             <div className="bg-[#e8e4df] p-12 rounded-2xl">
// //               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
// //                 Get in Touch with<br />Vedamsa
// //               </h1>
// //               <p className="text-gray-700 text-lg leading-relaxed mb-12">
// //                 Whether you have questions, want to schedule a tour, or need assistance with a listing, our team is ready to assist.
// //               </p>

// //               {/* Contact Information */}
// //               <div className="space-y-8">
// //                 {/* Address */}
// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Address</h3>
// //                   <p className="text-gray-900 font-medium flex items-start">
// //                     <MapPin className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
// //                     Hyderabad, Telangana, India
// //                   </p>
// //                 </div>

// //                 {/* Email */}
// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Email</h3>
// //                   <a 
// //                     href="mailto:Vedamsa@gmail.com" 
// //                     className="text-gray-900 font-medium hover:text-[#3d2817] transition-colors duration-300 flex items-center"
// //                   >
// //                     <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
// //                     Vedamsa@gmail.com
// //                   </a>
// //                 </div>

// //                 {/* Phone */}
// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Phone</h3>
// //                   <a 
// //                     href="tel:+918885852266" 
// //                     className="text-gray-900 font-medium hover:text-[#3d2817] transition-colors duration-300 flex items-center"
// //                   >
// //                     <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
// //                     +91 8885852266
// //                   </a>
// //                 </div>

// //                 {/* Hours */}
// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">Hours</h3>
// //                   <div className="text-gray-900 font-medium flex items-start">
// //                     <Clock className="w-5 h-5 mr-2 mt-1 flex-shrink-0" />
// //                     <div>
// //                       <p>Mon-Fri: 9am–6pm</p>
// //                       <p className="text-gray-500">Sat - Sun: Closed</p>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Right - Contact Form with Dark Marble Background */}
// //             <div className="relative overflow-hidden rounded-2xl shadow-2xl">
// //               {/* Dark Marble Background */}
// //               <div 
// //                 className="absolute inset-0 bg-cover bg-center"
// //                 style={{
// //                   backgroundImage: `url('https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=800')`,
// //                 }}
// //               ></div>
// //               <div className="absolute inset-0 bg-black/60"></div>
              
// //               {/* Form */}
// //               <div className="relative z-10 p-12">
// //                 <form onSubmit={handleSubmit} className="space-y-6">
// //                   <div>
// //                     <input
// //                       type="text"
// //                       name="name"
// //                       placeholder="Name"
// //                       value={formData.name}
// //                       onChange={handleChange}
// //                       required
// //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// //                     />
// //                   </div>

// //                   <div>
// //                     <input
// //                       type="email"
// //                       name="email"
// //                       placeholder="Email"
// //                       value={formData.email}
// //                       onChange={handleChange}
// //                       required
// //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// //                     />
// //                   </div>

// //                   <div>
// //                     <input
// //                       type="tel"
// //                       name="phone"
// //                       placeholder="Phone (optional)"
// //                       value={formData.phone}
// //                       onChange={handleChange}
// //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500"
// //                     />
// //                   </div>

// //                   <div>
// //                     <textarea
// //                       name="message"
// //                       placeholder="Message"
// //                       value={formData.message}
// //                       onChange={handleChange}
// //                       required
// //                       rows="6"
// //                       className="w-full px-6 py-4 bg-white/95 backdrop-blur-sm rounded-xl border-none focus:outline-none focus:ring-2 focus:ring-[#3d2817] text-gray-900 placeholder-gray-500 resize-none"
// //                     ></textarea>
// //                   </div>

// //                   <button
// //                     type="submit"
// //                     className="w-full bg-[#3d2817] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#2d1f10] transition-all duration-300 flex items-center justify-center space-x-2 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
// //                   >
// //                     <span>Send Message</span>
// //                     <Send className="w-5 h-5" />
// //                   </button>
// //                 </form>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Location Section */}
// //       <section className="py-20 px-6 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
// //             {/* Left - Content */}
// //             <div>
// //               <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// //                 Hyderabad, India
// //               </h2>
// //               <p className="text-gray-600 text-lg leading-relaxed mb-8">
// //                 Vedamsa's headquarters serve as the central hub for managing diverse property portfolios and delivering expert real estate solutions to forward-thinking teams across dynamic markets.
// //               </p>

// //               <div className="space-y-6">
// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">[ADDRESS]</h3>
// //                   <p className="text-gray-900 font-medium">Isnapur, Hyderabad, Telangana, India</p>
// //                 </div>

// //                 <div>
// //                   <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">[CONTACT]</h3>
// //                   <p className="text-gray-900 font-medium">+91 8885852266</p>
// //                   <p className="text-gray-600">Monday–Friday: 9:00 AM – 6:00 PM</p>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Right - Image */}
// //             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[600px]">
// //               <img 
// //                 src={post4}
// //                 alt="Vedamsa Office"
// //                 className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Why Vedamsa Section */}
// //       <section className="py-20 px-6 bg-[#f5f3f0]">
// //         <div className="max-w-6xl mx-auto">
// //           <div className="text-center mb-16">
// //             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
// //               [KEEP IN TOUCH]
// //             </span>
// //             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
// //               Why Vedamsa Stands Out
// //             </h2>
// //             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
// //               With nearly 30 years of expertise in the construction industry, Vedamsa has become a trusted name in Hyderabad. Here's what sets Vedamsa apart:
// //             </p>
// //           </div>

// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// //             {/* Feature Cards */}
// //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// //                 <Building2 className="w-6 h-6" />
// //               </div>
// //               <h3 className="text-xl font-bold text-gray-900 mb-3">Customer-Centric Approach</h3>
// //               <p className="text-gray-600 leading-relaxed">
// //                 Over 3000 satisfied customers are a testament to Vedamsa's dedication to delivering quality.
// //               </p>
// //             </div>

// //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// //                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
// //                 </svg>
// //               </div>
// //               <h3 className="text-xl font-bold text-gray-900 mb-3">Unmatched Expertise</h3>
// //               <p className="text-gray-600 leading-relaxed">
// //                 Vedamsa brings years of experience to every project from plotting to construction.
// //               </p>
// //             </div>

// //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// //                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
// //                 </svg>
// //               </div>
// //               <h3 className="text-xl font-bold text-gray-900 mb-3">Sustainability</h3>
// //               <p className="text-gray-600 leading-relaxed">
// //                 Environmentally conscious designs that ensure a greener tomorrow.
// //               </p>
// //             </div>

// //             <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
// //               <div className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center mb-4">
// //                 <Clock className="w-6 h-6" />
// //               </div>
// //               <h3 className="text-xl font-bold text-gray-900 mb-3">Timely Delivery</h3>
// //               <p className="text-gray-600 leading-relaxed">
// //                 A proven track record of completing projects on time.
// //               </p>
// //             </div>
// //           </div>

// //           <div className="text-center mt-12">
// //             <p className="text-gray-700 text-lg font-medium">
// //               When you choose Vedamsa, you're not just buying a home; you're investing in a legacy of trust and excellence.
// //             </p>
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA Section */}
// //       <section className="py-20 px-6 bg-gray-900">
// //         <div className="max-w-4xl mx-auto text-center">
// //           <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
// //             Ready to Build Your Future?
// //           </h2>
// //           <p className="text-gray-300 text-lg leading-relaxed mb-12">
// //             Let's discuss your dream project. Our team is here to guide you every step of the way.
// //           </p>
// //           <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
// //             <a 
// //               href="tel:+918885852266"
// //               className="bg-white text-gray-900 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
// //             >
// //               Call Now: +91 8885852266
// //             </a>
// //             <a 
// //               href="mailto:Vedamsa@gmail.com"
// //               className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300"
// //             >
// //               Email Us
// //             </a>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <footer className="bg-[#2d1f10] text-white py-12 px-6">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
// //             <div>
// //               <div className="flex items-center space-x-3 mb-4">
// //                 <div className="bg-white text-gray-900 p-2 rounded">
// //                   <Building2 className="w-6 h-6" />
// //                 </div>
// //                 <span className="text-2xl font-bold">Vedamsa</span>
// //               </div>
// //               <p className="text-gray-400">Building Dreams, Creating Futures</p>
// //             </div>

// //             <div>
// //               <h4 className="font-bold mb-4">Contact</h4>
// //               <div className="space-y-2 text-gray-400">
// //                 <p>Hyderabad, India</p>
// //                 <p>+91 8885852266</p>
// //                 <p>Vedamsa@gmail.com</p>
// //               </div>
// //             </div>

// //             <div>
// //               <h4 className="font-bold mb-4">Hours</h4>
// //               <div className="space-y-2 text-gray-400">
// //                 <p>Monday - Friday</p>
// //                 <p>9:00 AM - 6:00 PM</p>
// //                 <p className="text-gray-500">Weekends: Closed</p>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="border-t border-gray-700 pt-8 text-center">
// //             <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
// //           </div>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // };

// // export default ContactPage;


// import React, { useState, useEffect, useRef } from 'react';
// import { Building2, MapPin, Mail, Phone, Clock, Send, CheckCircle } from 'lucide-react';
// import post4 from './Images/Poster-3.png';

// // PURE SILVER Reveal Image Component
// const RevealImage = ({ src, alt, className = "" }) => {
//   const wrapperRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setIsRevealed(true);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
//       <img 
//         src={src} 
//         alt={alt} 
//         className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
//           isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
//         }`}
//         style={{ transitionDelay: '800ms' }}
//       />
      
//       {/* PURE SILVER Gradient Mask */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
//           isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
//         }`}
//         style={{ 
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
//           background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
//         }}
//       />
      
//       {/* Silver Shimmer */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
//           isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
//         }`}
//         style={{ 
//           transitionDelay: '300ms',
//           background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
//         }}
//       />
//     </div>
//   );
// };

// // Reveal Content Component
// const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
//   const contentRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = contentRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setTimeout(() => {
//               setIsRevealed(true);
//             }, delay);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.15 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, [delay]);
  
//   const getTransform = () => {
//     if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
//     if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
//     if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
//     if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
//     return '';
//   };
  
//   return (
//     <div 
//       ref={contentRef} 
//       className={`transition-all duration-1000 ${
//         isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
//       } ${getTransform()} ${className}`}
//       style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
//     >
//       {children}
//     </div>
//   );
// };

// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: ''
//   });

//   const [focusedField, setFocusedField] = useState('');

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     alert('Thank you for your message! We will get back to you soon.');
//     setFormData({ name: '', email: '', phone: '', message: '' });
//   };

//   const contactInfo = [
//     {
//       icon: <MapPin className="w-5 h-5" />,
//       label: 'Address',
//       value: 'Hyderabad, Telangana, India',
//       link: null
//     },
//     {
//       icon: <Mail className="w-5 h-5" />,
//       label: 'Email',
//       value: 'Vedamsa@gmail.com',
//       link: 'mailto:Vedamsa@gmail.com'
//     },
//     {
//       icon: <Phone className="w-5 h-5" />,
//       label: 'Phone',
//       value: '+91 8885852266',
//       link: 'tel:+918885852266'
//     },
//     {
//       icon: <Clock className="w-5 h-5" />,
//       label: 'Hours',
//       value: 'Mon-Fri: 9am–6pm',
//       subValue: 'Sat - Sun: Closed',
//       link: null
//     }
//   ];

//   const features = [
//     {
//       icon: <Building2 className="w-6 h-6" />,
//       title: 'Customer-Centric Approach',
//       description: 'Over 3000 satisfied customers are a testament to Vedamsa\'s dedication to delivering quality.'
//     },
//     {
//       icon: <CheckCircle className="w-6 h-6" />,
//       title: 'Unmatched Expertise',
//       description: 'Vedamsa brings years of experience to every project from plotting to construction.'
//     },
//     {
//       icon: (
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//         </svg>
//       ),
//       title: 'Sustainability',
//       description: 'Environmentally conscious designs that ensure a greener tomorrow.'
//     },
//     {
//       icon: <Clock className="w-6 h-6" />,
//       title: 'Timely Delivery',
//       description: 'A proven track record of completing projects on time.'
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
//       {/* Hero Section */}
//       <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6 bg-gradient-to-b from-white to-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto text-center">
//           <RevealContent>
//             <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
//               [GET IN TOUCH]
//             </span>
//           </RevealContent>
//           <RevealContent delay={100}>
//             <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
//               Let's Start a <br className="hidden sm:block" />
//               <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">
//                 Conversation
//               </span>
//             </h1>
//           </RevealContent>
//           <RevealContent delay={200}>
//             <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto px-4">
//               Whether you have questions, want to schedule a tour, or need assistance with a listing, our team is ready to assist.
//             </p>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Main Contact Section - Split Layout */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
//             {/* Left - Contact Info */}
//             <RevealContent direction="right">
//               <div className="relative bg-gradient-to-br from-[#e8e4df] to-[#f5f3f0] p-8 sm:p-10 lg:p-12 rounded-2xl shadow-xl overflow-hidden">
//                 <div 
//                   className="absolute inset-0 opacity-5"
//                   style={{
//                     backgroundImage: 'radial-gradient(circle at 2px 2px, #8B7355 1px, transparent 0)',
//                     backgroundSize: '40px 40px'
//                   }}
//                 ></div>

//                 <div className="relative z-10">
//                   <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
//                     Get in Touch with Vedamsa
//                   </h2>
//                   <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-8 sm:mb-12">
//                     We're here to help you find your perfect property or answer any questions about our projects.
//                   </p>

//                   {/* Contact Information */}
//                   <div className="space-y-6 sm:space-y-8">
//                     {contactInfo.map((info, index) => (
//                       <div 
//                         key={index}
//                         className="group transform hover:-translate-y-1 transition-all duration-300"
//                       >
//                         <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2 sm:mb-3">
//                           {info.label}
//                         </h3>
//                         {info.link ? (
//                           <a 
//                             href={info.link}
//                             className="text-gray-900 font-medium hover:text-[#8B7355] transition-colors duration-300 flex items-start group"
//                           >
//                             <div className="flex-shrink-0 w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#8B7355] group-hover:text-white transition-all duration-300 shadow-md">
//                               {info.icon}
//                             </div>
//                             <div className="pt-2">
//                               <p className="text-sm sm:text-base">{info.value}</p>
//                               {info.subValue && <p className="text-gray-600 text-xs sm:text-sm mt-1">{info.subValue}</p>}
//                             </div>
//                           </a>
//                         ) : (
//                           <div className="flex items-start">
//                             <div className="flex-shrink-0 w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 shadow-md">
//                               {info.icon}
//                             </div>
//                             <div className="pt-2">
//                               <p className="text-gray-900 font-medium text-sm sm:text-base">{info.value}</p>
//                               {info.subValue && <p className="text-gray-600 text-xs sm:text-sm mt-1">{info.subValue}</p>}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>

//                   {/* Decorative Element */}
//                   <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#8B7355]/10 to-transparent rounded-tl-full transform translate-x-16 translate-y-16"></div>
//                 </div>
//               </div>
//             </RevealContent>

//             {/* Right - Contact Form */}
//             <RevealContent delay={150} direction="left">
//               <div className="relative overflow-hidden rounded-2xl shadow-2xl h-full">
//                 {/* Background */}
//                 <div 
//                   className="absolute inset-0 bg-cover bg-center"
//                   style={{
//                     backgroundImage: `url('https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=800')`,
//                   }}
//                 ></div>
//                 <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/90 to-[#6B5744]/95"></div>
                
//                 {/* Animated Pattern Overlay */}
//                 <div 
//                   className="absolute inset-0 opacity-10"
//                   style={{
//                     backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
//                     backgroundSize: '30px 30px',
//                     animation: 'movePattern 20s linear infinite'
//                   }}
//                 ></div>

//                 {/* Form */}
//                 <div className="relative z-10 p-8 sm:p-10 lg:p-12">
//                   <div className="mb-8">
//                     <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">Send us a message</h3>
//                     <p className="text-white/80 text-sm sm:text-base">Fill out the form below and we'll get back to you soon</p>
//                   </div>

//                   <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
//                     <div className="relative">
//                       <input
//                         type="text"
//                         name="name"
//                         placeholder="Your Name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         onFocus={() => setFocusedField('name')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                         className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
//                           focusedField === 'name' ? 'border-white' : 'border-transparent'
//                         } focus:outline-none text-gray-900 placeholder-gray-500 transition-all duration-300 shadow-lg text-sm sm:text-base`}
//                       />
//                     </div>

//                     <div className="relative">
//                       <input
//                         type="email"
//                         name="email"
//                         placeholder="Your Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         onFocus={() => setFocusedField('email')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                         className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
//                           focusedField === 'email' ? 'border-white' : 'border-transparent'
//                         } focus:outline-none text-gray-900 placeholder-gray-500 transition-all duration-300 shadow-lg text-sm sm:text-base`}
//                       />
//                     </div>

//                     <div className="relative">
//                       <input
//                         type="tel"
//                         name="phone"
//                         placeholder="Phone (optional)"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         onFocus={() => setFocusedField('phone')}
//                         onBlur={() => setFocusedField('')}
//                         className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
//                           focusedField === 'phone' ? 'border-white' : 'border-transparent'
//                         } focus:outline-none text-gray-900 placeholder-gray-500 transition-all duration-300 shadow-lg text-sm sm:text-base`}
//                       />
//                     </div>

//                     <div className="relative">
//                       <textarea
//                         name="message"
//                         placeholder="Your Message"
//                         value={formData.message}
//                         onChange={handleChange}
//                         onFocus={() => setFocusedField('message')}
//                         onBlur={() => setFocusedField('')}
//                         required
//                         rows="5"
//                         className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
//                           focusedField === 'message' ? 'border-white' : 'border-transparent'
//                         } focus:outline-none text-gray-900 placeholder-gray-500 resize-none transition-all duration-300 shadow-lg text-sm sm:text-base`}
//                       ></textarea>
//                     </div>

//                     <button
//                       type="submit"
//                       className="group w-full bg-white text-gray-900 px-6 sm:px-8 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 flex items-center justify-center space-x-2 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 relative overflow-hidden text-base sm:text-lg"
//                     >
//                       <span className="relative z-10">Send Message</span>
//                       <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300 relative z-10" />
//                       <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//                     </button>
//                   </form>
//                 </div>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* Location Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
//             {/* Left - Content */}
//             <div>
//               <RevealContent direction="right">
//                 <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
//                   [OUR LOCATION]
//                 </span>
//               </RevealContent>
//               <RevealContent delay={100} direction="right">
//                 <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
//                   Hyderabad, <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">India</span>
//                 </h2>
//               </RevealContent>
//               <RevealContent delay={200} direction="right">
//                 <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
//                   Vedamsa's headquarters serve as the central hub for managing diverse property portfolios and delivering expert real estate solutions to forward-thinking teams across dynamic markets.
//                 </p>
//               </RevealContent>

//               <div className="space-y-4 sm:space-y-6">
//                 <RevealContent delay={300} direction="right">
//                   <div className="bg-[#f5f3f0] p-4 sm:p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
//                     <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2">[ADDRESS]</h3>
//                     <p className="text-gray-900 font-medium text-sm sm:text-base">Isnapur, Hyderabad, Telangana, India</p>
//                   </div>
//                 </RevealContent>

//                 <RevealContent delay={400} direction="right">
//                   <div className="bg-[#f5f3f0] p-4 sm:p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
//                     <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2">[CONTACT]</h3>
//                     <p className="text-gray-900 font-medium text-sm sm:text-base">+91 8885852266</p>
//                     <p className="text-gray-600 text-xs sm:text-sm mt-1">Monday–Friday: 9:00 AM – 6:00 PM</p>
//                   </div>
//                 </RevealContent>
//               </div>
//             </div>

//             {/* Right - Image */}
//             <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px]">
//               <RevealImage 
//                 src={post4}
//                 alt="Vedamsa Office"
//                 className="w-full h-full"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              
//               {/* Floating Badge */}
//               <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-xl shadow-2xl">
//                 <p className="text-[#8B7355] text-xs sm:text-sm font-bold">Vedamsa Headquarters</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Why Vedamsa Section */}
//       <section className="py-12 sm:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-12 sm:mb-16">
//             <RevealContent>
//               <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
//                 [WHY CHOOSE US]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
//                 Why Vedamsa <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Stands Out</span>
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto px-4">
//                 With nearly 30 years of expertise in the construction industry, Vedamsa has become a trusted name in Hyderabad. Here's what sets Vedamsa apart:
//               </p>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12">
//             {features.map((feature, index) => (
//               <RevealContent 
//                 key={index} 
//                 delay={index * 150}
//                 direction={index % 2 === 0 ? 'right' : 'left'}
//               >
//                 <div className="group relative bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden">
//                   <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
//                   <div className="relative z-10">
//                     <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
//                       {feature.icon}
//                     </div>
//                     <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#8B7355] transition-colors duration-300">
//                       {feature.title}
//                     </h3>
//                     <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
//                       {feature.description}
//                     </p>
//                   </div>

//                   <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-[#8B7355]/10 to-transparent rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>

//           <RevealContent delay={600}>
//             <div className="text-center bg-white p-6 sm:p-8 rounded-2xl shadow-lg">
//               <p className="text-gray-700 text-base sm:text-lg md:text-xl font-medium">
//                 When you choose Vedamsa, you're not just buying a home; you're investing in a <span className="text-[#8B7355] font-bold">legacy of trust and excellence</span>.
//               </p>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="relative py-20 sm:py-32 px-4 sm:px-6 overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center bg-fixed"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 to-black/90"></div>
        
//         <div 
//           className="absolute inset-0 opacity-10"
//           style={{
//             backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
//             backgroundSize: '50px 50px',
//             animation: 'movePattern 20s linear infinite'
//           }}
//         ></div>

//         <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
//           <RevealContent>
//             <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 drop-shadow-2xl">
//               Ready to Build Your Future?
//             </h2>
//           </RevealContent>
//           <RevealContent delay={100}>
//             <p className="text-white/90 text-base sm:text-lg md:text-xl leading-relaxed mb-8 sm:mb-12 px-4 drop-shadow-lg">
//               Let's discuss your dream project. Our team is here to guide you every step of the way.
//             </p>
//           </RevealContent>
//           <RevealContent delay={200}>
//             <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
//               <a 
//                 href="tel:+918885852266"
//                 className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-105 text-base sm:text-lg relative overflow-hidden"
//               >
//                 <span className="relative z-10">Call Now: +91 8885852266</span>
//                 <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//               </a>
//               <a 
//                 href="mailto:Vedamsa@gmail.com"
//                 className="bg-transparent border-2 border-white text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-white hover:text-gray-900 transition-all duration-500 text-base sm:text-lg"
//               >
//                 Email Us
//               </a>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Footer */}
//       {/* <footer className="bg-[#1a1410] text-white py-12 px-4 sm:px-6 relative overflow-hidden">
//         <div 
//           className="absolute inset-0 opacity-5"
//           style={{
//             backgroundImage: 'linear-gradient(30deg, #8B7355 12%, transparent 12.5%, transparent 87%, #8B7355 87.5%)',
//             backgroundSize: '80px 140px'
//           }}
//         ></div>

//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-8">
//             <div>
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white p-2 rounded-lg shadow-lg">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400">Building Dreams, Creating Futures</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4 text-lg">Contact</h4>
//               <div className="space-y-2 text-gray-400 text-sm">
//                 <p>Hyderabad, India</p>
//                 <p>+91 8885852266</p>
//                 <p>Vedamsa@gmail.com</p>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4 text-lg">Hours</h4>
//               <div className="space-y-2 text-gray-400 text-sm">
//                 <p>Monday - Friday</p>
//                 <p>9:00 AM - 6:00 PM</p>
//                 <p className="text-gray-500">Weekends: Closed</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">© 2025 Vedamsa. All rights reserved.</p>
//           </div>
//         </div>
//       </footer> */}

//       <style jsx>{`
//         @keyframes movePattern {
//           0% {
//             transform: translate(0, 0);
//           }
//           100% {
//             transform: translate(50px, 50px);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ContactPage;



import React, { useState, useEffect, useRef } from 'react';
import { Building2, MapPin, Mail, Phone, Clock, Send, CheckCircle, Loader2 } from 'lucide-react';
import emailjs from '@emailjs/browser';
import post4 from './Images/Poster-3.png';

// PURE SILVER Reveal Image Component
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

// Reveal Content Component
const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  const getTransform = () => {
    if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
    if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
    if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
    if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
    return '';
  };
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      } ${getTransform()} ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const ContactPage = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const [focusedField, setFocusedField] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  // Initialize EmailJS
  useEffect(() => {
    // Replace with your EmailJS public key
    emailjs.init('YOUR_PUBLIC_KEY');
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Get current date and time
      const now = new Date();
      const formattedTime = now.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

      // Replace these with your EmailJS credentials
      const result = await emailjs.send(
        'service_6k0r9e9',     // Your EmailJS service ID
        'template_fzovn1b',    // Your EmailJS template ID
        {
          name: formData.name,
          phone: formData.phone,
          message: formData.message,
          time: formattedTime,
          to_name: 'Vedamsa Team',
        },
        'NsunIySUKyhMp6Kzv'      // Your EmailJS public key
      );

      console.log('Email sent successfully:', result.text);
      setSubmitStatus('success');
      setFormData({ name: '', phone: '', message: '' });
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);

    } catch (error) {
      console.error('Email send failed:', error);
      setSubmitStatus('error');
      
      // Reset error message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <MapPin className="w-5 h-5" />,
      label: 'Address',
      value: 'Hyderabad, Telangana, India',
      link: null
    },
    {
      icon: <Mail className="w-5 h-5" />,
      label: 'Email',
      value: 'Vedamsa@gmail.com',
      link: 'mailto:Vedamsa@gmail.com'
    },
    {
      icon: <Phone className="w-5 h-5" />,
      label: 'Phone',
      value: '+91 8885852266',
      link: 'tel:+918885852266'
    },
    {
      icon: <Clock className="w-5 h-5" />,
      label: 'Hours',
      value: 'Mon-Fri: 9am–6pm',
      subValue: 'Sat - Sun: Closed',
      link: null
    }
  ];

  const features = [
    {
      icon: <Building2 className="w-6 h-6" />,
      title: 'Customer-Centric Approach',
      description: 'Over 3000 satisfied customers are a testament to Vedamsa\'s dedication to delivering quality.'
    },
    {
      icon: <CheckCircle className="w-6 h-6" />,
      title: 'Unmatched Expertise',
      description: 'Vedamsa brings years of experience to every project from plotting to construction.'
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Sustainability',
      description: 'Environmentally conscious designs that ensure a greener tomorrow.'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Timely Delivery',
      description: 'A proven track record of completing projects on time.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
      {/* Hero Section */}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6 bg-gradient-to-b from-white to-[#f5f3f0]">
        <div className="max-w-7xl mx-auto text-center">
          <RevealContent>
            <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
              [GET IN TOUCH]
            </span>
          </RevealContent>
          <RevealContent delay={100}>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              Let's Start a <br className="hidden sm:block" />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">
                Conversation
              </span>
            </h1>
          </RevealContent>
          <RevealContent delay={200}>
            <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto px-4">
              Whether you have questions, want to schedule a tour, or need assistance with a listing, our team is ready to assist.
            </p>
          </RevealContent>
        </div>
      </section>

      {/* Main Contact Section - Split Layout */}
      <section className="py-12 sm:py-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Left - Contact Info */}
            <RevealContent direction="right">
              <div className="relative bg-gradient-to-br from-[#e8e4df] to-[#f5f3f0] p-8 sm:p-10 lg:p-12 rounded-2xl shadow-xl overflow-hidden">
                <div 
                  className="absolute inset-0 opacity-5"
                  style={{
                    backgroundImage: 'radial-gradient(circle at 2px 2px, #8B7355 1px, transparent 0)',
                    backgroundSize: '40px 40px'
                  }}
                ></div>

                <div className="relative z-10">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                    Get in Touch with Vedamsa
                  </h2>
                  <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-8 sm:mb-12">
                    We're here to help you find your perfect property or answer any questions about our projects.
                  </p>

                  {/* Contact Information */}
                  <div className="space-y-6 sm:space-y-8">
                    {contactInfo.map((info, index) => (
                      <div 
                        key={index}
                        className="group transform hover:-translate-y-1 transition-all duration-300"
                      >
                        <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2 sm:mb-3">
                          {info.label}
                        </h3>
                        {info.link ? (
                          <a 
                            href={info.link}
                            className="text-gray-900 font-medium hover:text-[#8B7355] transition-colors duration-300 flex items-start group"
                          >
                            <div className="flex-shrink-0 w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#8B7355] group-hover:text-white transition-all duration-300 shadow-md">
                              {info.icon}
                            </div>
                            <div className="pt-2">
                              <p className="text-sm sm:text-base">{info.value}</p>
                              {info.subValue && <p className="text-gray-600 text-xs sm:text-sm mt-1">{info.subValue}</p>}
                            </div>
                          </a>
                        ) : (
                          <div className="flex items-start">
                            <div className="flex-shrink-0 w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3 shadow-md">
                              {info.icon}
                            </div>
                            <div className="pt-2">
                              <p className="text-gray-900 font-medium text-sm sm:text-base">{info.value}</p>
                              {info.subValue && <p className="text-gray-600 text-xs sm:text-sm mt-1">{info.subValue}</p>}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Decorative Element */}
                  <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#8B7355]/10 to-transparent rounded-tl-full transform translate-x-16 translate-y-16"></div>
                </div>
              </div>
            </RevealContent>

            {/* Right - Contact Form */}
            <RevealContent delay={150} direction="left">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl h-full">
                {/* Background */}
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://images.unsplash.com/photo-1615799998603-7c6270a45196?w=800')`,
                  }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/90 to-[#6B5744]/95"></div>
                
                {/* Animated Pattern Overlay */}
                <div 
                  className="absolute inset-0 opacity-10"
                  style={{
                    backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
                    backgroundSize: '30px 30px',
                    animation: 'movePattern 20s linear infinite'
                  }}
                ></div>

                {/* Form */}
                <div className="relative z-10 p-8 sm:p-10 lg:p-12">
                  <div className="mb-8">
                    <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">Send us a message</h3>
                    <p className="text-white/80 text-sm sm:text-base">Fill out the form below and we'll get back to you soon</p>
                  </div>

                  {/* Success/Error Message */}
                  {submitStatus === 'success' && (
                    <div className="mb-6 p-4 bg-green-500/20 border-2 border-green-400 rounded-xl backdrop-blur-sm">
                      <div className="flex items-center space-x-2 text-white">
                        <CheckCircle className="w-5 h-5" />
                        <p className="font-medium">Message sent successfully! We'll get back to you soon.</p>
                      </div>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="mb-6 p-4 bg-red-500/20 border-2 border-red-400 rounded-xl backdrop-blur-sm">
                      <div className="flex items-center space-x-2 text-white">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="font-medium">Failed to send message. Please try again or contact us directly.</p>
                      </div>
                    </div>
                  )}

                  <form ref={formRef} onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                    <div className="relative">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        onFocus={() => setFocusedField('name')}
                        onBlur={() => setFocusedField('')}
                        required
                        disabled={isSubmitting}
                        className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
                          focusedField === 'name' ? 'border-white' : 'border-transparent'
                        } focus:outline-none text-gray-900 placeholder-gray-500 transition-all duration-300 shadow-lg text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed`}
                      />
                    </div>

                    <div className="relative">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        onFocus={() => setFocusedField('phone')}
                        onBlur={() => setFocusedField('')}
                        required
                        disabled={isSubmitting}
                        className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
                          focusedField === 'phone' ? 'border-white' : 'border-transparent'
                        } focus:outline-none text-gray-900 placeholder-gray-500 transition-all duration-300 shadow-lg text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed`}
                      />
                    </div>

                    <div className="relative">
                      <textarea
                        name="message"
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleChange}
                        onFocus={() => setFocusedField('message')}
                        onBlur={() => setFocusedField('')}
                        required
                        rows="5"
                        disabled={isSubmitting}
                        className={`w-full px-5 sm:px-6 py-3 sm:py-4 bg-white/95 backdrop-blur-sm rounded-xl border-2 ${
                          focusedField === 'message' ? 'border-white' : 'border-transparent'
                        } focus:outline-none text-gray-900 placeholder-gray-500 resize-none transition-all duration-300 shadow-lg text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed`}
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="group w-full bg-white text-gray-900 px-6 sm:px-8 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 flex items-center justify-center space-x-2 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 relative overflow-hidden text-base sm:text-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                    >
                      {isSubmitting ? (
                        <>
                          <Loader2 className="w-5 h-5 animate-spin relative z-10" />
                          <span className="relative z-10">Sending...</span>
                        </>
                      ) : (
                        <>
                          <span className="relative z-10">Send Message</span>
                          <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300 relative z-10" />
                        </>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    </button>
                  </form>
                </div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left - Content */}
            <div>
              <RevealContent direction="right">
                <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                  [OUR LOCATION]
                </span>
              </RevealContent>
              <RevealContent delay={100} direction="right">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Hyderabad, <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">India</span>
                </h2>
              </RevealContent>
              <RevealContent delay={200} direction="right">
                <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                  Vedamsa's headquarters serve as the central hub for managing diverse property portfolios and delivering expert real estate solutions to forward-thinking teams across dynamic markets.
                </p>
              </RevealContent>

              <div className="space-y-4 sm:space-y-6">
                <RevealContent delay={300} direction="right">
                  <div className="bg-[#f5f3f0] p-4 sm:p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
                    <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2">[ADDRESS]</h3>
                    <p className="text-gray-900 font-medium text-sm sm:text-base">Isnapur, Hyderabad, Telangana, India</p>
                  </div>
                </RevealContent>

                <RevealContent delay={400} direction="right">
                  <div className="bg-[#f5f3f0] p-4 sm:p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
                    <h3 className="text-xs sm:text-sm font-bold text-[#8B7355] uppercase tracking-wider mb-2">[CONTACT]</h3>
                    <p className="text-gray-900 font-medium text-sm sm:text-base">+91 8885852266</p>
                    <p className="text-gray-600 text-xs sm:text-sm mt-1">Monday–Friday: 9:00 AM – 6:00 PM</p>
                  </div>
                </RevealContent>
              </div>
            </div>

            {/* Right - Image */}
            <div className="relative overflow-hidden rounded-2xl shadow-2xl group h-[400px] sm:h-[500px] lg:h-[600px]">
              <RevealImage 
                src={post4}
                alt="Vedamsa Office"
                className="w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              
              {/* Floating Badge */}
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-xl shadow-2xl">
                <p className="text-[#8B7355] text-xs sm:text-sm font-bold">Vedamsa Headquarters</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Vedamsa Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 bg-[#f5f3f0]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <RevealContent>
              <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-4 sm:mb-6 block">
                [WHY CHOOSE US]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
                Why Vedamsa <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Stands Out</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <p className="text-gray-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-4xl mx-auto px-4">
                With nearly 30 years of expertise in the construction industry, Vedamsa has become a trusted name in Hyderabad. Here's what sets Vedamsa apart:
              </p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12">
            {features.map((feature, index) => (
              <RevealContent 
                key={index} 
                delay={index * 150}
                direction={index % 2 === 0 ? 'right' : 'left'}
              >
                <div className="group relative bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white rounded-xl flex items-center justify-center mb-4 sm:mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                      {feature.icon}
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#8B7355] transition-colors duration-300">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      {feature.description}
                    </p>
                  </div>

                  <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-[#8B7355]/10 to-transparent rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
                </div>
              </RevealContent>
            ))}
          </div>

          <RevealContent delay={600}>
            <div className="text-center bg-white p-6 sm:p-8 rounded-2xl shadow-lg">
              <p className="text-gray-700 text-base sm:text-lg md:text-xl font-medium">
                When you choose Vedamsa, you're not just buying a home; you're investing in a <span className="text-[#8B7355] font-bold">legacy of trust and excellence</span>.
              </p>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-20 sm:py-32 px-4 sm:px-6 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 to-black/90"></div>
        
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            animation: 'movePattern 20s linear infinite'
          }}
        ></div>

        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <RevealContent>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 drop-shadow-2xl">
              Ready to Build Your Future?
            </h2>
          </RevealContent>
          <RevealContent delay={100}>
            <p className="text-white/90 text-base sm:text-lg md:text-xl leading-relaxed mb-8 sm:mb-12 px-4 drop-shadow-lg">
              Let's discuss your dream project. Our team is here to guide you every step of the way.
            </p>
          </RevealContent>
          <RevealContent delay={200}>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <a 
                href="tel:+918885852266"
                className="group bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-105 text-base sm:text-lg relative overflow-hidden"
              >
                <span className="relative z-10">Call Now: +91 8885852266</span>
                <div className="absolute inset-0 bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </a>
              <a 
                href="mailto:Vedamsa@gmail.com"
                className="bg-transparent border-2 border-white text-white px-8 sm:px-10 py-4 sm:py-5 rounded-xl font-bold hover:bg-white hover:text-gray-900 transition-all duration-500 text-base sm:text-lg"
              >
                Email Us
              </a>
            </div>
          </RevealContent>
        </div>
      </section>

      <style jsx>{`
        @keyframes movePattern {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
      `}</style>
    </div>
  );
};

export default ContactPage;